import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { StockTrackingChartInterval } from '@toro/common/shared/components/charts/stock-tracking-chart/stock-tracking-chart-interval';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { TrTrackingChartComponent } from '../tr-tracking-chart/tr-tracking-chart.component';

@Component({
    selector: 'stock-tracking-charts-wraper',
    templateUrl: 'stock-tracking-charts-wraper.component.html',
    styleUrls: ['./stock-tracking-charts-wraper.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class StockTrackingChartsWraperComponent implements OnInit {

    @Input() public market: OrderMarketTypeEnum;
    @Input() public stopLoss: number;
    @Input() public stopGainLabel: string;
    @Input() public stopLossLabel: string;
    @Input() public side: OrderSideEnum;
    @Input() public currentResultLabel: string;
    @Input() public stopGain: number;
    @Input() public set code(value: string) {
        this._code = value.toUpperCase();
    }
    public get code(): string {
        return this._code;
    }

    @Output() public onGainHit: EventEmitter<number> = new EventEmitter();
    @Output() public onStopHit: EventEmitter<number> = new EventEmitter();
    public filterOptions = StockTrackingChartInterval;
    public currentActiveTabIndex: number = 0;
    private interval: number;
    private charts: TrTrackingChartComponent[] = [];
    // tslint:disable-next-line:variable-name
    private _code: string;

    constructor(public store: Store<AppState>) { }

    public addChart(chart: TrTrackingChartComponent) {
        this.charts.push(chart);
    }

    public ngOnInit() {

        this.store.dispatch({ type: StocksMarketAction.getLastHourHistory, payload: this.code });
        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.code });

        setTimeout(() => {
            if (this.charts.length) {
                // plota o primeiro gráfico
                this.charts[0].foreground = true;
            }
        });

    }

    /**
     * Exibe um gráfico (perído)
     * @param interval período
     * @param chartIndex índice do gráfico
     */
    public showChart(interval: StockTrackingChartInterval, chartIndex: number) {

        this.currentActiveTabIndex = chartIndex;
        for (const chart of this.charts) {
            chart.foreground = false;
        }

        if (this.charts[chartIndex].plotted) {
            this.charts[chartIndex].showLastPointMarker(true);
        }

        this.charts[chartIndex].foreground = true;

        switch (interval) {
            case StockTrackingChartInterval.OneDay:
                this.store.dispatch({type: StocksMarketAction.getLastDayHistory, payload: this.code });
                break;
            case StockTrackingChartInterval.OneWeek:
                this.store.dispatch({type: StocksMarketAction.getLastWeekHistory, payload: this.code });
                break;
            case StockTrackingChartInterval.OneMonth:
                this.store.dispatch({type: StocksMarketAction.getLastMonthHistory, payload: this.code });
                break;
            case StockTrackingChartInterval.TwoMonths:
                this.store.dispatch({type: StocksMarketAction.getLastTwoMonthsHistory, payload: this.code });
                break;
            case StockTrackingChartInterval.OneYear:
                this.store.dispatch({type: StocksMarketAction.getLastYearHistory, payload: this.code });
                break;
            case StockTrackingChartInterval.FiveYears:
                this.store.dispatch({type: StocksMarketAction.getLastFiveYearsHistory, payload: this.code });
                break;
        }
    }

    /**
     * Hanlder para quando o stop gain for atingido
     * @param value valor da cotação no momento
     */
    public onGainHitHandler(value: number) {
        this.onGainHit.emit(value);
    }

    /**
     * Hanlder para quando o stop loss for atingido
     * @param value valor da cotação no momento
     */
    public onStopHitHandler(value: number) {
        this.onStopHit.emit(value);
    }

    public ngOnDestroy() {
        this.store.dispatch({type: StocksMarketAction.resetQuoteHistoryState, payload: this.code});
        this.store.dispatch({type: StocksMarketAction.unsubscribeQuotes, payload: this.code});
    }
}
